import { DependencyList, useLayoutEffect, useState } from 'react';

export interface UseCondensedHeaderProps {
  getRootElement: () => HTMLElement | null;
  deps?: DependencyList;
}

export const useCondensedHeader = ({
  getRootElement,
  deps = [],
}: UseCondensedHeaderProps) => {
  const [isScrolledEnough, setIsScrolledEnough] = useState(false);

  useLayoutEffect(() => {
    const rootElement = getRootElement();

    if (!rootElement) {
      return undefined;
    }

    const handleScroll = () => {
      const shouldCondense = rootElement.scrollTop > 0;
      setIsScrolledEnough(shouldCondense);
    };

    rootElement.addEventListener('scroll', handleScroll, { passive: true });

    return () => rootElement.removeEventListener('scroll', handleScroll);
  }, deps);

  return isScrolledEnough;
};
